import React from 'react';
import './SkipLink.css';

/**
 * Skip link component for keyboard navigation accessibility
 * Allows users to skip to main content
 */
const SkipLink = ({ targetId = 'main-content', label = 'Skip to main content' }) => {
  return (
    <a href={`#${targetId}`} className="skip-link">
      {label}
    </a>
  );
};

export default SkipLink;

